import React from "react";
import { getProfileSession } from "../../../redux/actions/dbactions/profileActions";

const Transactions = ({ transactions }) => {
  const { profileData } = getProfileSession();
  const { user_first_name, user_last_name } = profileData;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        Transaction History
      </h2>

      {/* <div className="mb-4 p-4 bg-gray-100 rounded-lg flex justify-between items-center text-gray-800">
        <p className="font-medium text-lg">
          Total Transactions:{" "}
          <span className="font-bold">{transactions.length}</span>
        </p>
        <p className="font-medium text-lg">
          Total Amount:{" "}
          <span className={"font-bold"}>${totalAmount.toFixed(2)}</span>
        </p>
        <p className="font-medium text-lg">
          Balance Left:{" "}
          <span className="text-blue-600 font-bold">
            ${balanceLeft.toFixed(2)}
          </span>
        </p>
      </div> */}

      <div className="overflow-auto rounded-lg shadow-md">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200 text-gray-700 text-center">
              <th className="border border-gray-300 px-4 py-3">
                Transaction ID
              </th>
              <th className="border border-gray-300 px-4 py-3">User</th>
              <th className="border border-gray-300 px-4 py-3">Amount</th>
              <th className="border border-gray-300 px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.length > 0 ? (
              transactions.map((transaction) => (
                <tr
                  key={transaction.id}
                  className="text-center bg-white hover:bg-gray-100 transition"
                >
                  <td className="border border-gray-300 px-4 py-3">
                    {transaction.id}
                  </td>
                  <td className="border border-gray-300 px-4 py-3">
                    {transaction.user_profile?.user_first_name ||
                      user_first_name}{" "}
                    {transaction.user_profile?.user_last_name || user_last_name}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 font-semibold">
                    <span>${Math.abs(transaction.amount).toFixed(2)}</span>
                  </td>
                  <td className="border border-gray-300 px-4 py-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        transaction.status === "completed"
                          ? "bg-green-200 text-green-800"
                          : "bg-red-200 text-red-800"
                      }`}
                    >
                      {transaction.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-gray-500 py-4">
                  No transactions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Transactions;
